import {api} from "./api";

export const cities = async (zone_id) => {
    return await api.lpost(
        'cities',
        `zone_id=${zone_id}`
    )
}